// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Phone: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M13.25 9.79l-2.783-1.194a1.25 1.25 0 00-1.442.358l-.906 1.106a8.603 8.603 0 01-3.427-3.426L5.8 5.727c.429-.353.57-.934.351-1.445l-1.19-2.784A1.243 1.243 0 003.543.782L.962 1.38A1.23 1.23 0 000 2.585C0 9.292 5.458 14.75 12.165 14.75c.58 0 1.078-.395 1.208-.96l.596-2.584a1.244 1.244 0 00-.718-1.416zm-.73 3.803a.367.367 0 01-.354.282C5.94 13.875.876 8.811.876 2.585a.36.36 0 01.282-.352l2.582-.6a.366.366 0 01.417.21l1.191 2.782a.366.366 0 01-.103.426L3.864 6.183a.437.437 0 00-.115.53 9.471 9.471 0 004.29 4.29c.182.091.403.043.532-.114l1.131-1.381a.369.369 0 01.424-.105l2.778 1.19c.162.07.25.246.211.417l-.594 2.583z" />
        </svg>
    );
};

export default React.memo(Phone);
